



















































































import { defineComponent } from '@vue/composition-api'
import { useStore } from '@/store'
import VSlider from '@/components/VSlider.vue'

export default defineComponent({
  name: 'OudeHavenkranen',

  components: {
    VSlider
  },

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()

    return {
      state
    }
  }
})
